<script>
/* eslint no-unused-vars: 'off' */
import common from '@/scripts/common';
import current from '@/scripts/current';
import threeStateCheckboxList from '@/components/threeStateCheckboxList';
import oldThreeStateCheckboxList from '@/components/oldThreeStateCheckboxList';
import threeStateCheckboxList2 from '@/components/threeStateCheckboxList2';

function checkboxInputsChanged(l, controlName) {
    const vm = this;
    vm.selectedLevels[controlName] = l;
    vm.$emit('filtersChanged', vm.selectedLevels);
}

export default {
    props: ['reportModel'],
    components: {
        // <my-component> will only be available in parent's template
        threeStateCheckboxList,
        threeStateCheckboxList2,
        oldThreeStateCheckboxList
    },
    render(h) {
        const vm = this;
        const p = vm.reportModel.parms;
        const v = vm.selectionModel.v;
        const s = vm.selectedLevels;

        if (!v.control1.include) return '';
        const header1 = (
            <div class="a-header">{p.control1.variable.variableTitle}</div>
        );
        let header2 = '';

        let selection1 = createThreeStateCheckboxList(
            h,
            vm.control1Levels,
            s.control1,
            (l) => vm.checkboxInputsChanged(l, 'control1')
        );
        let selection2 = '';

        if (v.control2.include) {
            header2 = (
                <div class="a-header">{p.control2.variable.variableTitle}</div>
            );

            //header2 = h("div", {}, p.control2.variable.variableTitle);
            selection2 = createThreeStateCheckboxList(
                h,
                vm.control2Levels,
                s.control2,
                (l) => vm.checkboxInputsChanged(l, 'control2')
            );
        }

        const noLevelsSelected =
            s.control1.length === 0 || s.control2.length === 0;
        let noSelections = '';
        if (noLevelsSelected)
            noSelections = (
                <div style="font-size: larger">
                    Select at least one level from each control variable above
                    to view a report.
                </div>
            );
        return (
            <div>
                <div class="well">
                    <h3>Filter Control Variable Levels</h3>
                    <div class="hidden-xs collapse">
                        {header1}
                        {header2}
                    </div>
                    <div class="the-selections">
                        {header1}
                        {selection1}
                        {header2}
                        {selection2}
                    </div>
                    <div>
                        <div>
                            Select one or more levels to show for each control
                        </div>
                    </div>
                </div>
                {noSelections}
            </div>
        );
    },
    //   computed: {
    //     selectedLevelsControl1: function () {
    //       return this.selectedLevels.control1;
    //     },
    //     selectedLevelsControl2: function () {
    //       return this.selectedLevels.control2;
    //     },
    //   },
    //   watch: {
    //     selectedLevelsControl1(value) {
    //       this.$emit("filtersChanged", this.selectedLevels);
    //     },
    //     selectedLevelsControl2(value) {
    //       this.$emit("filtersChanged", this.selectedLevels);
    //     },
    //   },
    created: function () {
        const vm = this;
        vm.control1Levels = current.selectionModel.v.control1.include
            ? levelsToKeyValuePairs(
                  vm.reportModel.levelsGroupedByControl1,
                  'control1Level'
              )
            : [];
        vm.control2Levels = current.selectionModel.v.control2.include
            ? levelsToKeyValuePairs(
                  vm.reportModel.levelsGroupedByControl1[0]
                      .levelsGroupedByControl2,
                  'control2Level'
              )
            : [];
        if (vm.control2Levels.length === 0)
            vm.control1Levels = vm.control1Levels.filter((l) => l.value !== 0);

        vm.selectedLevels.control1 = vm.control1Levels.map((l) => l.value);
        vm.selectedLevels.control2 = vm.control2Levels.map((l) => l.value);
        vm.selectionModel = current.selectionModel;
        vm.$emit('filtersChanged', vm.selectedLevels);

        // dunno why v-on="resize: func" not working
        global.window.addEventListener('resize', function (event, b, c) {});
    },
    data: function () {
        var vm = this;
        var model = {
            control1Levels: [],
            control2Levels: [],
            selectedLevels: {
                control1: [],
                control2: []
            },
            theCount: 0,
            selectionModel: null
        };

        return model;
    },
    methods: {
        checkboxInputsChanged
    }
};

function levelsToKeyValuePairs(levels, levelName) {
    return levels.map((l) => ({
        value: l[levelName].id,
        title: l[levelName].title
    }));
}

// function createOldThreeStateCheckboxList(h, levels, selections, onInput) {
//     let checkboxList = h(resolveComponent('old-three-state-checkbox-list'), {
//         props: {
//             levels,
//             selections
//         },
//         on: {
//             input: onInput
//         }
//     });
//     return <div class="the-checkbox-list">{checkboxList}</div>;
// }

// function createThreeStateCheckboxList2(h, levels, selections, onInput) {
//     let checkboxList = h(resolveComponent('three-state-checkbox-list2'), {
//         props: {
//             levels,
//             selections
//         },
//         on: {
//             input: onInput
//         }
//     });
//     return <div class="the-checkbox-list">{checkboxList}</div>;
// }

function createThreeStateCheckboxList(h, levels, selections, onInput) {
    let checkboxList = h('three-state-checkbox-list2', {
        props: {
            levels,
            selections
        },
        on: {
            input: onInput
        }
    });
    const results = <div class="the-checkbox-list">{checkboxList}</div>;
    //return results;
    return [
        //createThreeStateCheckboxList2(h, levels, selections, onInput),
        results
    ];
}
</script>

<style scoped>
h3 {
    font-family: Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 18px;
}
h3 {
    display: block;
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}

div.clear-button {
    margin-top: 5px;
    font-size: smaller;
}

div.the-checkbox-list {
    width: 48%;
    float: left;
    margin-right: 2%;
}
div.a-header {
    font-weight: 450;
    margin-right: 5px;
    margin-bottom: 5px;
}

@media (min-width: 768px) {
    .visible-xs,
    div.the-selections > div.a-header {
        display: none;
    }
    div.a-header {
        width: 48%;
        float: left;
        margin-right: 2%;
    }
}

@media (max-width: 767px) {
    .hidden-xs {
        display: none !important;
    }
    div.the-checkbox-list {
        width: 100%;
        float: left;
    }
}

.well {
    display: grid;
    min-height: 20px;
    padding: 19px;
    margin: 0 5px 20px 10px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%);
    box-sizing: border-box;
}

h3 {
    font-family: Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 18px;
}
</style>